"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.envConfigBaseDefault = void 0;
exports.envConfigBaseDefault = {
    environment: 'local',
    appVersion: '',
    appName: 'EggKat',
    buildTime: '',
    appStoreUrl: '',
    googlePlayUrl: '',
    publicUrl: 'http://192.168.0.127:3003',
    privacyUrl: '/legal.html?show=privacy-policy',
    termsUrl: '/legal.html',
    maxMessagingTokens: 10,
    descriptionMaxLength: 200,
    workingStaleSeconds: 15,
    feedbackWorkspaceId: '',
    // the following configs is only used for new workspaces and should not be used for logic on current workspaces
    uploadCapacityGigabytesPerUserPro: 0.2,
    uploadCapacityGigabytesPerUserFree: 0.1,
    workspaceMaxUserCountFree: 3,
    workspaceMaxUserCountPro: 10,
    // end
    enableWorkspaceLogo: true,
    enableRoles: false,
    enableReaderRole: true,
    enableWriterRole: true,
    enableOwnerRole: true,
    enableVerifyEmail: false,
    enableLoginRedirect: true,
};
